<template>
    <div style='margin: 10px'>
        <div class="container-fluid">
            <cfg cid="shopCart.destinatarioIndirizzo" tag='div'>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addAddressLabels.destinatarioLbl}}</span>
                    </div>
                    <input-w v-model="destinatarioValue" :configs="destinatarioConfigs">
                        <div class="col-sm-8"><input  v-model="destinatarioValue" type="text" id="destinatarioId" class="form-control form-control-cust" /></div>
                    </input-w>
                </div>
            </div>
            </cfg>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addAddressLabels.indirizzoLbl}}{{indirizzoConfigs.mandatory}}</span>
                    </div>
                    <input-w v-model="indirizzoValue" :configs="indirizzoConfigs">
                        <div class="col-sm-8"><input  v-model="indirizzoValue" type="text" id="indirizzoId" class="form-control form-control-cust" /></div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addAddressLabels.capLbl}}{{capConfigs.mandatory}}</span>
                    </div>
                    <input-w v-model="capValue" :configs="capConfigs">
                        <div class="col-sm-8"><input  v-model="capValue" type="text" id="capId" class="form-control form-control-cust" /></div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addAddressLabels.localitaLbl}}{{localitaConfigs.mandatory}}</span>
                    </div>
                    <input-w v-model="localitaValue" :configs="localitaConfigs">
                        <div class="col-sm-8"><input  v-model="localitaValue" type="text" id="localitaId" class="form-control form-control-cust" /></div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addAddressLabels.nazioneLbl}}{{nazioneConfigs.mandatory}}</span>
                    </div>
                    <input-w v-model="nazioneValue" :configs="nazioneConfigs">
                        <div class="col-sm-8"> 
                            <v-select label="type" style="width: 100%;" :menuStyle="{position: 'relative','max-height':'150px','height':'150px'}" :options="nazioniList" 
                                v-model="nazioneValue" @input="onNazioneDropdownChange(nazioneValue)" :placeholder="$Jed.firstUpperTranslate('select')+' '+$Jed.translate('country')">
                            </v-select>           
                        </div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addAddressLabels.provinciaLbl}}{{provinciaConfigs.mandatory}}</span>
                    </div>
                    <input-w v-if="$Behaviors.allowFreeProvince" v-model="provinciaValue" :configs="provinciaConfigs">
                        <div class="col-sm-8">
                            <input  v-model="provinciaValue" type="text" id="provinciaId" class="form-control form-control-cust" />
                        </div>
                    </input-w>
                    <input-w v-else v-model="provinciaValue" :configs="provinciaConfigs">
                        <div class="col-sm-8"> 
                            <v-select label="type" style="width: 100%;" :menuStyle="{position: 'relative','max-height':'150px','height':'150px'}" :options="provincesList" 
                                v-model="provinciaValue" :placeholder="$Jed.firstUpperTranslate('select')+' '+$Jed.translate('province')">
                            </v-select>           
                        </div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addAddressLabels.regioneLbl}}</span>
                    </div>
                    <input-w v-model="regioneValue" :configs="regioneConfigs">
                        <div class="col-sm-8">
                            <input  v-model="regioneValue" type="text" id="regioneId" class="form-control form-control-cust" />
                        </div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">&nbsp;</div>
                <div class="col-md-6">&nbsp;</div>
            </div>
            <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6">
                    <div class="controls col-sm-5">
                        <button @click.prevent="cancelClick" class="btn btn-danger"  style="width: auto;">{{addAddressLabels.annullaBtnLbl}}</button>
                    </div>
                    <div class="controls col-sm-1">&nbsp;
                    </div>
                    <div class="controls col-sm-5">
                        <button @click.prevent="confirmClick" class="btn btn-primary-default"  style="width: auto;">{{addAddressLabels.confermaBtnLbl}}</button>
                    </div>
                    <div class="controls col-sm-1">&nbsp;
                    </div>
                </div>
            </div>
        </div>    
    </div>    
</template>

<script>

import InputW from '../../dynamic/inputWrapper/inputWrapper.vue'
import FormMixin from '../../dynamic/inputWrapper/formMixin.js'
import DynTableWrapper from "../../dynamic/DynTableWrapper.vue";
import table_resize_mixin from "../../../mixins/table_resize_mixin.js";
import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"
import { eventBus } from "../../../eventbus";
import Cfg from "../../dynamic/ConfigurableComponent.vue";

export default {
    mixins: [FormMixin],
    components: {
        InputW,
        DynTableWrapper,
        vSelect,
        Cfg
    },
    props: {
        addressObj: null
    },
    data: function () {
        var vm = this;
        return {
            destinatarioConfigs: {
                id: "genericselect",
                editable: false
            },
                indirizzoConfigs: {
                id: "genericselect",
                editable: false,
                mandatory: "*"
            },
                capConfigs: {
                id: "genericselect",
                editable: false,
                mandatory: "*"
            },
                localitaConfigs: {
                id: "genericselect",
                editable: false,
                mandatory: "*"
            },
                provinciaConfigs: {
                id: "genericselect",
                editable: false,
                mandatory: vm.$Behaviors.allowFreeProvince ? '' : "*"
            },
                regioneConfigs: {
                id: "genericselect",
                editable: false
            },
                nazioneConfigs: {
                id: "genericselect",
                editable: false,
                mandatory: "*"
            },
            addAddressLabels: {
                destinatarioLbl: vm.$Jed.firstUpperTranslate('recipient'),
                indirizzoLbl: vm.$Jed.firstUpperTranslate('address'), 
                capLbl: vm.$Jed.firstUpperTranslate('postal code'),
                localitaLbl: vm.$Jed.firstUpperTranslate('place'), 
                provinciaLbl: vm.$Jed.firstUpperTranslate('province'),
                regioneLbl: vm.$Jed.firstUpperTranslate('region'), 
                nazioneLbl: vm.$Jed.firstUpperTranslate('country'), 
                annullaBtnLbl: vm.$Jed.firstUpperTranslate('cancel'), 
                confermaBtnLbl: vm.$Jed.firstUpperTranslate('confirm')
            },
            idA: -1,
            destinatarioValue: "",
            indirizzoValue: "",
            capValue: "",
            localitaValue: "",
            provinciaValue: "",
            provincesList: [],
            regioneValue: '',
            nazioneValue: '',
            nazioniList: [],
            reg_nations: null,
            reg_provinces: null,
            reg_zones: null
        }
    },
    created: function() {
        this.loadCollections();
    },
    mounted: function() {
        this.updateData();
    },
    methods: {
        updateData() {
            if( this.addressObj != null) {
                this.idA = this.addressObj.obj.id,
                this.indirizzoValue = this.addressObj.obj.add,
                this.capValue = this.addressObj.obj.cap; 
                this.localitaValue = this.addressObj.obj.loc; 
                this.regioneValue = this.addressObj.obj.reg; 
                this.provinciaValue = this.addressObj.obj.pro; 
            }
        },
        cancelClick() {
            this.$emit("onCancelAddAddressEvent");
        },
        confirmClick() {
            try{
                var isOk = true;

                function checkData(data, varName) {
                    if(validate.isEmpty(data)){
                        alert('Dati mancanti in ', varName);
                        isOk = false;
                    }
                }

                checkData(this.indirizzoValue, 'indirizzoValue');
                checkData(this.capValue, 'capValue');
                checkData(this.localitaValue, 'localitaValue');
                checkData(this.nazioneValue,'nazioneValue');
                if(!this.$Behaviors.allowFreeProvince){
                    checkData(this.provinciaValue, 'provinciaValue');
                }

                var reg_addresses = this.$root.dbRegistry.getCollection('addresses');
                this.idA = reg_addresses.data.length > 0 ? "-"+(reg_addresses.maxId + 1) : -1;

                if(isOk) {
                    let now = new Date();
                    var data = {
                        id: this.idA, 
                        add: this.indirizzoValue,
                        cap: this.capValue, 
                        loc: this.localitaValue, 
                        pid: this.$Behaviors.allowFreeProvince ? '' : this.provinciaValue.value,  // id provincia (per gli indirizzi inseriti dall'utente non deve essere valorizzato)
                        reg: this.regioneValue, 
                        pro: this.$Behaviors.allowFreeProvince ? this.provinciaValue : this.provinciaValue.type,
                        sip: this.$Behaviors.allowFreeProvince ? '' : this.provinciaValue.type,
                        nat: this.nazioneValue,
                        tel: '',
                        fax: '',
                        cel: '',
                        mai: '',// mail
                        con: this.destinatarioValue, // contatto (nome persona)
                        sti: '', // id magazzino
                        cii: '', // id cliente inserimento
                        cld: '', // giorno chiusura
                        mdt: now, // data modifica
                    }
                    this.$emit("onConfirmAddAddressEvent", data);

                    //svuoto i campi per un eventuale nuovo inserimento
                    this.indirizzoValue = null
                    this.capValue = null
                    this.localitaValue = null
                    this.regioneValue = null
                    this.provinciaValue = null
                    this.nazioneValue = null
                    this.destinatarioValue = null
                }else{
                    eventBus.$emit("alert", {type: "warning", message: this.$Jed.firstUpperTranslate('Insert at least: address, zip code, place and nation')});
                }
            }catch(err) {
                console.log(err);
            }
        },
        async loadCollections() {
            var vm = this;
            try {
                vm.reg_zones = await vm.$root.fetchRegistryData("zones", "GetZones", "collection")
                vm.reg_provinces = await this.$root.fetchRegistryData("provinces", "GetProvinces", "collection")

                if(this.$root.preferences.useOffline){
                    if(vm.$root.dbServRegistry == null ) {
                        console.log("AddAddress - Registry not loaded!");
                        return;
                    }else{
                        vm.reg_nations = vm.$root.dbServRegistry.getCollection('nations');
                    }   
                }else{
                    vm.reg_nations = vm.$root.dbRegistry.getCollection('nations');
                }

               var current_lang = vm.$root.token.siglaLingua;
                
                if( vm.reg_nations != null) {
                    var nations = vm.reg_nations.chain().simplesort("des").data();
                    vm.nazioniList = [];
                    nations.forEach(function(nation) { 
                        vm.nazioniList.push({
                            value: nation.id,
                            type: nation.des[current_lang] ? nation.des[current_lang] : nation.des[vm.$root.token.defaultLang],
                            obj: nation 
                        });
                    });
                }
            } catch (error) {
                console.log(error);       
            }
        },
        onNazioneDropdownChange: function(val){
            var vm = this;
            console.log('onNazioneDropdownChange: ', val)
            var zonesList = [];
            try {            
                var zone = 0;
                if(vm.reg_zones && val) {
                    var zones = vm.reg_zones.find({'nat': val.value});
                    console.log(zones)
                    zones.forEach(function(z){
                        //zonesList.push({id: z.id, name: z.nam, obj: z})
                        console.log(z.id)
                        if(vm.reg_provinces) {
                            var provinces = vm.reg_provinces.find({'zid': z.id});
                            //console.log(provinces)
                            provinces.forEach(function(item) { 
                                vm.provincesList.push({value: item.id, type: item.pro, obj: item});
                            });
                        }
                    });
                   //console.log(vm.provincesList)
                }
            } catch (error) {
                console.log(error);     
            }
        }
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/AddAddress.vue?ec79477c